import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const NoDataComponent = () => {
  const { t } = useTranslation('translations');
  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100%" width="100%">
      <Typography variant="p">{t('NoDataAvailable')}</Typography>
    </Box>
  );
};

export default NoDataComponent;
